(() => {
  const rootUrl = () => {
    const base = window.Shopify?.routes?.root || '/';
    return base.endsWith('/') ? base : `${base}/`;
  };

  const enhance = (root = document) => {
    root.querySelectorAll('[data-fb-buy-now]').forEach((button) => {
      if (button.dataset.fbBuyReady === 'true') return;
      button.dataset.fbBuyReady = 'true';

      const form = button.closest('form[action*="/cart/add"]');
      if (!form) return;

      const sync = () => {
        const variant = form.querySelector('[name="id"]')?.value;
        const addButton = form.querySelector('[data-add-button], button[name="add"]');
        const unavailable = !variant || addButton?.disabled || addButton?.getAttribute('aria-disabled') === 'true';
        button.disabled = Boolean(unavailable);
      };

      button.addEventListener('click', async () => {
        if (button.disabled) return;
        const label = button.dataset.fbBuyNowLabel || 'Comprar ahora';
        button.disabled = true;
        button.textContent = 'Cargando…';
        try {
          const response = await fetch(`${rootUrl()}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          window.location.assign(`${rootUrl()}checkout`);
        } catch (error) {
          console.error('[Forever Bloom] Comprar ahora:', error);
          button.disabled = false;
          button.textContent = label;
        }
      });

      form.addEventListener('change', sync);
      form.addEventListener('input', sync);
      new MutationObserver(sync).observe(form, {
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'value']
      });
      sync();
    });
  };

  const observer = new MutationObserver(() => enhance());
  const init = () => {
    enhance();
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
